import { render } from "./비자발급및유학.vue?vue&type=template&id=bfd41a32"
import script from "./비자발급및유학.vue?vue&type=script&lang=js"
export * from "./비자발급및유학.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__